import { Component, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { passwordsCompareAsTheSame, passwordValidator } from '@core/validators';
import { AuthenticationService } from '@core/services';

@Component({
  templateUrl: "./reset-password.component.html",
  styleUrls: [
    "../../core/Styles/AccountShared/account-styles.css",
    "./reset-password.component.css"
  ]
})
export class ResetPasswordComponent implements OnDestroy {

  public formSubmitAttempt: boolean = false;
  private unsubscribe$: Subject<void> = new Subject<void>();
  public form: FormGroup = new FormGroup({
    password: new FormControl('', [
      Validators.required,
      passwordValidator
    ]),
    confirmPassword: new FormControl('', [
      Validators.required
    ]),
    email: new FormControl(''),
    token: new FormControl(''),
  }, [passwordsCompareAsTheSame('password', 'confirmPassword')])

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
  ) {
    this.subscribeToRoute();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get password() { return this.form.get('password'); }

  get confirmPassword() { return this.form.get('confirmPassword'); }

  private subscribeToRoute(): void {
    this.route.queryParams
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(params => {
        if (params.token && params.email) {
          this.form.get('email').setValue(params.email);
          this.form.get('token').setValue(params.token);
        } else {
          this.router.navigate(['/'])
        }
      });
  }

  public submit(): void {
    this.formSubmitAttempt = true;
    if (this.form.valid) {
      this.authService.resetPassword(this.form.value)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: () => {
            this.router.navigate(['/sign-in']);
          },
          error: err => {
            console.log('error----', err);
          }
        });
    }
  }
}
